export default __webpack_public_path__ + "static/media/tarekprofile.d4925f61.jpg";